import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { toast } from "react-toastify";
import getHeaderTitle from "../../utils/getCurrentHead";

function Header() {
  const { user } = useUser();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { setIsSimpleUser, resetUser } = useUser();

  const handleSubmit = () => {
    resetUser();
    toast.success("Logged out successfully");
    navigate("/login");
  };
  return (
    <>
      <div className="main_header d-flex flex-column justify-content-center px-3">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="text-blue fw-semibold text-2xl">
            {getHeaderTitle(pathname)}
          </h3>
          <div className="d-flex align-items-center gap-3">
            <img
              src="/images/setting-ico.svg"
              alt=""
              className="cursor-pointer"
              onClick={() => navigate("/settings")}
            />
            <img
              className="cursor-pointer"
              src="/images/logout-ico.svg"
              onClick={handleSubmit}
              alt=""
            />
            <div className="profile-symbol">
              <img
                src="https://www.gravatar.com/avatar/2c7d99fe281ecd3bcd65ab915bac6dd5?s=250"
                alt=""
                className="symbol-img"
              />
            </div>
            <h5 className="mb-0 text-sm">{user.name || user.username}</h5>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
